import { useHasPermission } from '@clean-code/hooks/usePermissions';
import { useFeatureFlags } from '@hooks/useFeatureFlags';

/**
 * The production import posts to `/production-advancements/basic/bulk` with basic production and to
 * `/production-advancements/bulk` with full production, and each route checks its own key. It reads
 * the company-level flags and lets basic win, as the import itself does, so the key checked is the
 * one the import's route requires.
 */
export const useCanImportProduction = (): boolean => {
  const hasPermission = useHasPermission();
  const { prodBasic, prodFull } = useFeatureFlags();
  if (prodBasic) {
    return hasPermission('production_advancement', 'basic.bulk.create');
  }
  if (prodFull) {
    return hasPermission('production_advancement', 'bulk.create');
  }
  return false;
};
